var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Bulk/Checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2666 4.27986C13.4271 4.61125 13.2886 5.00996 12.9572 5.17042C9.51325 6.83792 7.38538 9.89572 6.40233 11.7428C6.22935 12.0678 5.82563 12.1911 5.50061 12.0181C5.17559 11.8451 5.05234 11.4414 5.22533 11.1163C6.27229 9.14925 8.57158 5.81243 12.3761 3.97035C12.7075 3.8099 13.1062 3.94847 13.2666 4.27986Z",
    fill: "#318D1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82401 8.08814C3.06157 7.80681 3.48218 7.77134 3.76349 8.00888C4.82231 8.90301 5.69669 9.93115 6.38658 11.0889C6.57506 11.4051 6.47145 11.8143 6.15517 12.0028C5.83888 12.1913 5.42968 12.0877 5.2412 11.7714C4.6287 10.7436 3.85153 9.82834 2.90325 9.02761C2.62194 8.79008 2.58647 8.36941 2.82401 8.08814Z",
    fill: "#318D1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Checkmark.8c04c386c9907a9d3c0e5ba0f7081606.svg";
export { ForwardRef as ReactComponent };